export const quiz = {
    topic: 'Javascript',
    level: 'Beginner',
    totalQuestions: 7,
    perQuestionScore: 5,
    questions: [
      {
        question:
          'Which function is used to serialize an object into a JSON string in Javascript?',
        choices: ['stringify()', 'parse()', 'convert()', 'None of the above'],
        type: 'MCQs',
        correctAnswer: 'stringify()',
      },
      {
        question:
          'Which of the following keywords is used to define a variable in Javascript?',
        choices: ['var', 'let', 'var and let', 'None of the above'],
        type: 'MCQs',
        correctAnswer: 'var and let',
      },
      {
        question:
          'Which of the following methods can be used to display data in some form using Javascript?',
        choices: [
          'document.write()',
          'console.log()',
          'window.alert',
          'All of the above',
        ],
        type: 'MCQs',
        correctAnswer: 'All of the above',
      },
      {
        question: 'How can a datatype be declared to be a constant type?',
        choices: ['const', 'var', 'let', 'constant'],
        type: 'MCQs',
        correctAnswer: 'const',
      },
      {
        question: 'Which of the following is the capital of Arunachal Pradesh?',
        choices: ['Dispur', 'Dehradun', 'Panaji', 'Itanagar'],
        type: 'MCQs',
        correctAnswer: 'Itanagar',
      },
      {
        question: 'In which of the following state, the main language is Khasi?',
        choices: ['Mizoram', 'Nagaland', 'Meghalaya', 'Tripura'],
        type: 'MCQs',
        correctAnswer: 'Meghalaya',
      },
      {
        question: 'Which state has the largest area?',
        choices: ['Maharashtra', 'Madhya Pradesh', 'Uttar Pradesh', 'Rajasthan'],
        type: 'MCQs',
        correctAnswer: 'Rajasthan',
      },
    ],
  }